"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwAPIErrorSafely = throwAPIErrorSafely;
exports.default = void 0;

var _APIError = _interopRequireDefault(require("../models/APIError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Will throw a human readable APIError otherwise assumed "fatal" Error
 * @param error
 */
function throwAPIErrorSafely(fetchError) {
  if (fetchError.response && fetchError.response.body && fetchError.response.body.errors && fetchError.response.body.errors.length) {
    throw new _APIError.default(fetchError.response.body.errors);
  } else {
    throw fetchError;
  }
}

var _default = {
  throwAPIErrorSafely: throwAPIErrorSafely
};
exports.default = _default;
//# sourceMappingURL=MulesoftUtils.js.map